<div *ngIf="!isLoading; else showLoader"></div>

<ng-template #showLoader>
  <div id="myModal" class="loader-modal">
    <div
      class="loading-icon-wrapper"
      [class.has-progress]="isShowProgress"
      [style.--progress]="progress"
    >
      <svg
        class="loading-icon"
        width="892"
        height="519"
        viewBox="0 0 892 519"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <style>
          #target,
          #target-soft {
            fill: none;
            stroke: #0c73b3;
            stroke-width: 28;
            stroke-linecap: round;
            stroke-linejoin: miter;
            stroke-miterlimit: 10;
          }

          #target-soft {
            opacity: 0.5;
            filter: url(#soft-ends);
          }

          #text-group {
            transform-box: fill-box;
            transform-origin: center 80%;
            animation: text-bounce 1.6s cubic-bezier(0.34, 1.56, 0.64, 1)
              infinite;
          }

          @keyframes text-bounce {
            0%,
            100% {
              transform: translateY(0) scaleY(1);
            }
            20% {
              transform: translateY(-6px) scaleY(1.05);
            }
            35% {
              transform: translateY(0) scaleY(0.98);
            }
            50% {
              transform: translateY(-3px) scaleY(1.02);
            }
            65% {
              transform: translateY(0) scaleY(0.99);
            }
          }

          #text-group-part-1,
          #text-group-part-2 {
            transform-box: fill-box;
            transform-origin: center;
          }

          #text-group-part-1 {
            animation: orbit-part-1 4s ease-in-out infinite;
          }

          #text-group-part-2 {
            animation: orbit-part-2 4s ease-in-out infinite;
          }

          @keyframes orbit-part-1 {
            0% {
              transform: translate(10px, 0) scale(1);
            }
            12.5% {
              transform: translate(0, -6px) scale(0.97);
            }
            25% {
              transform: translate(-10px, 0) scale(1);
            }
            37.5% {
              transform: translate(0, 6px) scale(1.03);
            }
            50% {
              transform: translate(10px, 0) scale(1);
            }
            100% {
              transform: translate(10px, 0) scale(1);
            }
          }

          @keyframes orbit-part-2 {
            0%,
            50% {
              transform: translate(10px, 0) scale(1);
            }
            62.5% {
              transform: translate(0, 6px) scale(1.03);
            }
            75% {
              transform: translate(-10px, 0) scale(1);
            }
            87.5% {
              transform: translate(0, -6px) scale(0.97);
            }
            100% {
              transform: translate(10px, 0) scale(1);
            }
          }
        </style>
        <g clip-path="url(#clip0_640_3201)">
          <path
            d="M254.5 103C168.5 93 103.5 165 116.501 251C-41.9999 295.5 -3.49991 502 143.706 506H721.298C939.5 486 902 219 751 195C768 26.9997 577 -45.9999 481 68.4998C467 70.9997 452 79.4997 436.5 95.4997C381.5 43.4998 296.5 49.5 254.5 103Z"
            stroke="#C4E5FB"
            stroke-width="28"
          />
          <path
            id="target-soft"
            pathLength="100"
            d="M254.5 103C168.5 93 103.5 165 116.501 251C-41.9999 295.5 -3.49991 502 143.706 506H721.298C939.5 486 902 219 751 195C768 26.9997 577 -45.9999 481 68.4998C467 70.9997 452 79.4997 436.5 95.4997C381.5 43.4998 296.5 49.5 254.5 103Z"
          />
          <path
            id="target"
            pathLength="100"
            d="M254.5 103C168.5 93 103.5 165 116.501 251C-41.9999 295.5 -3.49991 502 143.706 506H721.298C939.5 486 902 219 751 195C768 26.9997 577 -45.9999 481 68.4998C467 70.9997 452 79.4997 436.5 95.4997C381.5 43.4998 296.5 49.5 254.5 103Z"
          />
          <path
            d="M311.243 135.739C331.942 150.147 347.373 170.92 355.189 194.899L395.232 305.296L460.412 125.584C462.47 119.423 464.935 113.406 467.797 107.575C458.308 114.023 449.985 122.038 443.181 131.277L436.505 140.371L429.828 131.277C421.224 119.525 410.185 109.77 397.462 102.681C384.739 95.5916 370.637 91.3354 356.117 90.203C341.598 89.0706 327.005 91.0892 313.338 96.1201C299.671 101.151 287.252 109.077 276.931 119.353C289.188 122.906 300.78 128.445 311.247 135.747"
            fill="#C4E5FB"
          />
          <path
            d="M364.431 390.29L386.439 329.61L339.516 200.196C334.05 183.533 324.308 168.596 311.263 156.877C298.218 145.158 282.327 137.067 265.177 133.412C262.2 132.778 259.2 132.301 256.173 131.943C253.076 131.574 249.962 131.35 246.831 131.273C246.043 131.254 245.262 131.181 244.473 131.181C238.569 131.18 232.676 131.695 226.862 132.72C213.89 134.971 201.494 139.773 190.39 146.848C179.286 153.923 169.696 163.13 162.173 173.936C153.179 186.848 147.337 201.689 145.116 217.268C142.895 232.847 144.357 248.73 149.385 263.641L153.008 274.327L141.727 274.585C120.608 275.041 100.173 282.161 83.3429 294.928C66.5122 307.695 54.1464 325.455 48.0125 345.671C41.8787 365.887 42.2902 387.524 49.1887 407.492C56.0872 427.459 69.1191 444.738 86.4233 456.855C104.246 469.402 125.698 475.745 147.477 474.906H147.773L362.262 474.676C360.845 473.102 359.525 471.448 358.308 469.717C353.639 463.14 350.645 455.52 349.588 447.523C348.53 439.526 349.44 431.39 352.239 423.824L364.431 390.29Z"
            fill="#C4E5FB"
          />
          <path
            d="M838.289 266.354C826.401 249.458 811.012 235.322 793.17 224.911C775.332 214.499 755.455 208.056 734.897 206.02C740.016 186.007 740.758 165.125 737.082 144.798C733.401 124.47 725.381 105.175 713.574 88.227C700.878 70.0497 684.132 55.075 664.651 44.4866C645.174 33.898 623.501 27.9862 601.343 27.2183C579.185 26.4504 557.155 30.8475 536.989 40.0619C516.828 49.2767 499.082 63.0559 485.158 80.3108C466.432 87.0238 449.701 98.345 436.501 113.23C425.301 100.515 411.485 90.3711 396.001 83.4911C380.516 76.6108 363.727 73.157 346.784 73.3658C329.842 73.5751 313.144 77.4416 297.834 84.7016C282.524 91.9613 268.963 102.443 258.078 115.43C246.725 114.097 235.238 114.431 223.982 116.422C208.865 119.044 194.418 124.64 181.478 132.884C168.539 141.128 157.363 151.857 148.597 164.45C139.143 178.022 132.666 193.439 129.59 209.691C126.513 225.942 126.908 242.66 130.747 258.749C107.186 261.412 84.995 271.186 67.1247 286.77C49.2539 302.355 36.5508 323.011 30.7055 345.992C24.86 368.973 26.149 393.19 34.4008 415.419C42.6531 437.649 57.477 456.843 76.9008 470.441C96.4485 484.215 119.784 491.593 143.697 491.558C145.101 491.558 146.512 491.535 147.928 491.481L402.781 491.208C403.224 491.208 403.647 491.139 404.081 491.127L716.078 491.466C717.82 491.524 719.555 491.554 721.285 491.558C747.447 491.52 773.093 484.307 795.443 470.71C817.793 457.112 835.985 437.645 848.047 414.431C860.108 391.213 865.574 365.134 863.855 339.029C862.132 312.922 853.285 287.788 838.282 266.357M348.205 89.9118C364.097 89.951 379.758 93.7164 393.935 100.906C408.108 108.095 420.397 118.508 429.82 131.308L436.497 140.406L443.174 131.308C449.974 122.068 458.297 114.052 467.789 107.606C464.928 113.436 462.462 119.451 460.408 125.612L395.224 305.323L355.185 194.927C349.276 176.914 339.059 160.617 325.42 147.451C311.781 134.286 295.133 124.651 276.924 119.384C295.845 100.51 321.481 89.9168 348.205 89.931M358.308 469.74C359.524 471.471 360.845 473.129 362.262 474.699L147.774 474.929H147.478C128.852 475.599 110.408 471.06 94.2201 461.82C78.032 452.585 64.7412 439.014 55.8416 422.635C46.942 406.257 42.7862 387.724 43.842 369.113C44.8974 350.502 51.122 332.556 61.8162 317.29C70.8716 304.42 82.8181 293.854 96.6962 286.439C110.574 279.024 125.998 274.966 141.728 274.593L153.008 274.339L149.389 263.63C144.36 248.718 142.898 232.835 145.119 217.255C147.34 201.675 153.182 186.833 162.178 173.921C169.701 163.119 179.292 153.917 190.395 146.847C201.498 139.777 213.893 134.979 226.862 132.732C232.678 131.707 238.572 131.192 244.478 131.193C245.247 131.193 246.047 131.266 246.832 131.285C249.966 131.359 253.078 131.589 256.178 131.955C259.205 132.312 262.205 132.793 265.178 133.428C282.32 137.086 298.203 145.178 311.24 156.895C324.278 168.611 334.015 183.544 339.478 200.2L386.401 329.614L364.389 390.29L357.466 409.307L352.201 423.824C349.401 431.39 348.49 439.526 349.547 447.523C350.605 455.52 353.597 463.14 358.266 469.717M845.635 370.415C840.335 400.479 824.343 427.617 800.612 446.819C776.878 466.017 747.005 475.991 716.497 474.895L399.331 474.549C393.935 474.537 388.624 473.229 383.839 470.733C379.058 468.236 374.946 464.628 371.853 460.205C368.76 455.785 366.776 450.685 366.07 445.338C365.363 439.987 365.954 434.548 367.793 429.475L376.028 406.849L476.031 131.132L476.116 130.882C483.466 108.71 496.751 88.9779 514.528 73.8293C517.493 71.3214 520.555 68.9019 523.758 66.6478C544.924 51.7358 570.178 43.73 596.066 43.7261C603.524 43.7296 610.966 44.3847 618.308 45.684C634.685 48.5267 650.339 54.59 664.358 63.5225C678.378 72.4553 690.489 84.08 699.985 97.7242C711.343 114.027 718.72 132.767 721.528 152.438C724.331 172.11 722.485 192.165 716.139 210.994L712.512 221.68L723.797 221.933C743.658 222.407 763.135 227.531 780.658 236.894C798.185 246.258 813.27 259.601 824.705 275.851C834.274 289.443 841.055 304.799 844.655 321.029C848.251 337.26 848.597 354.042 845.666 370.407"
            fill="white"
          />
          <path
            d="M845.682 370.415C840.382 400.479 824.389 427.617 800.658 446.819C776.924 466.017 747.051 475.991 716.543 474.895L399.378 474.549C393.981 474.537 388.67 473.229 383.885 470.733C379.105 468.236 374.992 464.628 371.899 460.205C368.806 455.785 366.822 450.685 366.115 445.338C365.409 439.987 366 434.548 367.839 429.475L476.055 131.132L476.139 130.882C483.489 108.71 496.774 88.9778 514.551 73.8293C517.516 71.3214 520.578 68.9019 523.781 66.6478C544.947 51.7358 570.201 43.73 596.089 43.7261C603.547 43.7296 610.989 44.3847 618.332 45.684C634.708 48.5278 650.362 54.5915 664.381 63.5252C678.401 72.4584 690.508 84.0835 700.005 97.728C711.362 114.031 718.739 132.771 721.547 152.442C724.351 172.113 722.505 192.168 716.158 210.998L712.531 221.683L723.816 221.937C743.678 222.41 763.155 227.534 780.678 236.898C798.205 246.262 813.289 259.604 824.724 275.855C834.293 289.447 841.074 304.803 844.674 321.033C848.27 337.263 848.616 354.046 845.685 370.411"
            fill="#C4E5FB"
          />
          <g id="text-group">
            <path
              d="M570.014 301.935H522.69L515.877 385.847H502.276L494.87 301.935H449.362L445.577 276.083H492.448L491.085 260.515H526.159L524.797 276.083H544.604V287.274H572.273L570.002 301.935H570.014ZM473.548 377.987H459.342L455.103 314.64H480.954L473.548 377.987ZM558.975 378.139H544.907L537.804 315.851H563.655L558.975 378.139ZM571.225 285.155H547.948L547.494 259.606H575.313L571.225 285.155ZM553.827 265.65L553.222 279.856H566.671L568.185 265.65H553.815H553.827Z"
              fill="#443E33"
            />
            <path
              d="M659.062 298.012H598.137L594.503 272.463H659.365L659.062 298.012ZM602.666 332.48L600.092 310.704H659.516V332.48H602.666ZM698.678 384.044H609.63L607.662 368.475H685.67L689.607 281.686H716.518L698.678 384.044ZM702.147 278.809H690.199L690.654 259.153H703.964L702.147 278.809ZM716.972 278.809H705.478L707.446 259.153H720L716.972 278.809Z"
              fill="#443E33"
            />
            <g id="text-group-part-1">
              <path
                d="M290.684 301.48H272.087L247.144 385.998H234.742L244.57 301.48H201.939L198.608 340.945H182.434L172 259H205.56L204.046 275.629H294.456L290.671 301.48H290.684Z"
                fill="#443E33"
              />
              <path
                d="M255.42 364.762V369.064C274.08 371.171 287.555 377.126 287.555 384.154C287.555 392.948 266.485 400.076 240.495 400.076C214.505 400.076 193.435 392.948 193.435 384.154C193.435 377.126 206.897 371.171 225.57 369.064V364.762C199.302 367.109 179.86 375.512 179.86 385.529C179.86 397.363 207.011 406.952 240.508 406.952C274.005 406.952 301.155 397.363 301.155 385.529C301.155 375.524 281.713 367.109 255.446 364.762H255.42Z"
                fill="#D8444C"
              />
            </g>
            <g id="text-group-part-2">
              <path
                d="M418.755 378.592H398.492L400.612 340.188H308.536L305.206 313.882H435.535L418.755 378.592ZM356.151 432.112H343.144V354.545L373.234 354.394L356.151 432.112Z"
                fill="#443E33"
              />
              <path
                d="M365.273 409.314V413.617C383.933 415.724 397.407 421.679 397.407 428.706C397.407 437.5 376.338 444.628 350.348 444.628C324.357 444.628 303.288 437.5 303.288 428.706C303.288 421.679 316.75 415.724 335.422 413.617V409.314C309.155 411.661 289.712 420.064 289.712 430.081C289.712 441.916 316.863 451.504 350.36 451.504C383.857 451.504 411.008 441.916 411.008 430.081C411.008 420.076 391.566 411.661 365.298 409.314H365.273Z"
                fill="#0C73B3"
              />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="soft-ends"
            x="-15%"
            y="-15%"
            width="130%"
            height="130%"
            filterUnits="objectBoundingBox"
          >
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="2.5"
              result="blur"
            />
            <feColorMatrix
              in="blur"
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      0 0 0 0.45 0"
              result="blurAlpha"
            />
            <feMerge>
              <feMergeNode in="blurAlpha" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <clipPath id="clip0_640_3201">
            <rect width="892" height="519" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <div class="progress-bar" *ngIf="isShowProgress" aria-hidden="true">
        <div class="progress-bar__fill"></div>
      </div>
    </div>
  </div>
</ng-template>
